/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type JiraAdminProformaDataConnectionsEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

const JiraAdminProformaDataConnectionsEntryPoint: EntryPoint<
	JiraAdminProformaDataConnectionsEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<JiraAdminProformaDataConnectionsEntryPointComponent>(
		/* webpackChunkName: "async-jira-admin-proforma-data-connections" */ './ui/index.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});

export default JiraAdminProformaDataConnectionsEntryPoint;
